import * as React from "react";
import { classNames } from "@/lib/util";

import "./Range.scss";

type RangeProps = {
    className?: string;
    id?: string;
    name?: string;
    value?: number;
    min?: number;
    max?: number;
    step?: number;
    disabled?: boolean;
    readOnly?: boolean;
    required?: boolean;
    autoFocus?: boolean;
    form?: string;
    list?: string;
    placeholder?: string;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function Range(props: RangeProps) {
    const { className } = props;
    return <input {...props} className={classNames("range", className)} type="range" />;
}
